import { API_URL } from "../../utils/contextHelpers";
import { api, buildQuery } from "./core";

export const getFiltrosReporteCotizacion = api("getFiltrosReporteCotizacion", () => `${API_URL}reporte/cotizaciones/filtro`);

export const getReporteCotizacion = api("getReporteCotizacion", (params) => `${API_URL}reporte/cotizaciones/tabla?${params.toString()}`);

export const getReporteCotizacionHistoria = api("getReporteCotizacionHistoria", (id) => `${API_URL}reporte/cotizaciones/historia?id=${id}`);

export const getReporteSelectCotizacion = api("getReporteSelectCotizacion", (id) => `${API_URL}reporte/cotizaciones/cotizacion?id=${id}`);

export const grabarEstadoCotizacion = api("grabarEstadoCotizacion", (id, id_detalles, id_estado, id_estados) => `${API_URL}reporte/cotizaciones/estado/grabar?${buildQuery({
    id,
    id_detalles,
    id_estado,
    id_estados,
})}`);

export const cambiarFechaDecision = api("cambiarFechaDecision", (id, fecha) => `${API_URL}reporte/cotizaciones/cambiaFechaDecision?fecha=${encodeURIComponent(fecha)}&id=${id}`);

export const cambiarFechaEntrega = api("cambiarFechaEntrega", (id, fecha) => `${API_URL}reporte/cotizaciones/cambiaFechaEntrega?fecha=${encodeURIComponent(fecha)}&id=${id}`);

export const enviarCotizacion = api("enviarCotizacion", (id) => `${API_URL}reporte/cotizaciones/enviar?id=${id}`);

export const getFaseCotizacion = api("getFaseCotizacion", (id) => `${API_URL}reporte/cotizaciones/fase?id=${id}`);

export const cambiarEstadosCotizacion = api("cambiarEstadosCotizacion", (ids_cotizacion, id_estado) => `${API_URL}reporte/cotizaciones/cambiaEstados?${buildQuery({
    "id_cotizacion[]": ids_cotizacion,
    id_estado,
})}`);


